import { Renderer, Transform } from '@ancienttech/glass';

export default class PlanetRenderer extends Renderer {
    constructor(context) {
        super(context);
        const solarFrame = new Transform()
            .queueFixedScaling(0.1, 0.1, 0.1)
            .queueFixedTranslation(-1.07, 0, 0.18);
        this.solarTransform = new Transform()
            .queueFixedScaling(0.5, 0.5, 0.5)
            .queueOtherTransform(solarFrame);
        const planetFrame = new Transform()
            .queueFixedScaling(0.5, 0.5, 0.5)
            .queueFixedTranslation(0, -2.0, 0)
            .queueContinuousZRotation(0.0005)
            .queueOtherTransform(solarFrame);
        this.planetTransform = new Transform()
            .queueFixedScaling(0.5, 0.5, 0.5)
            .queueOtherTransform(planetFrame)
        this.moonTransform = new Transform()
            .queueFixedScaling(0.25, 0.25, 0.25)
            .queueFixedTranslation(0, -1.5, 0)
            .queueContinuousZRotation(0.0011)
            .queueOtherTransform(planetFrame);
    }

    async customInitAsync() {
        this.program = await this.context.loadProgramAsync(require('../shaders/gbuffer.vert'), require('../shaders/gbuffer.frag'), ["in_position", "in_textureCoord"], ["u_texture0", "u_modelMatrix", "u_viewMatrix", "u_projectionMatrix"]);
        this.textures = await this.context.loadTexturesAsync([
            {url:require('../textures/39_slab marble breciia aurora texture-seamless.jpg'), magFilter:this.context.gl.LINEAR, minFilter:this.context.gl.LINEAR}
        ]);
        this.sunVao = this.context.getCentered2x2CubeMesh().makeDrawVao({ positions: this.program.attributes.in_position, colorUV: this.program.attributes.in_textureCoord });
        this.planetVao = this.context.getCentered2x2CubeMesh().makeDrawVao({ positions: this.program.attributes.in_position, colorUV: this.program.attributes.in_textureCoord });
        this.moonVao = this.context.getCentered2x2CubeMesh().makeDrawVao({ positions: this.program.attributes.in_position, colorUV: this.program.attributes.in_textureCoord });
    }

    destroy() {
        super.destroy();
        const GL = this.context.gl;
        this.sunVao.destroy();
        this.planetVao.destroy();
        this.moonVao.destroy();
        for (let texture of this.textures) {
            GL.deleteTexture(texture);
        }
        this.program.destroy();
    }

    customRender(frameInfo, mountBufferFunc, properties) {
        mountBufferFunc();

        const GL = this.context.gl;
        GL.enable(GL.CULL_FACE);
        GL.enable(GL.DEPTH_TEST);

        GL.useProgram(this.program.program);
        this.context.bindTextures(this.textures, [this.program.uniforms.u_texture0]);

        GL.uniformMatrix4fv(this.program.uniforms.u_viewMatrix, false, properties.matrices.view);
        GL.uniformMatrix4fv(this.program.uniforms.u_projectionMatrix, false, properties.matrices.projection);

        GL.uniformMatrix4fv(this.program.uniforms.u_modelMatrix, false, this.solarTransform.getMatrix(frameInfo.timestampMS, properties));
        this.sunVao.draw();
        GL.uniformMatrix4fv(this.program.uniforms.u_modelMatrix, false, this.planetTransform.getMatrix(frameInfo.timestampMS, properties));
        this.planetVao.draw();
        GL.uniformMatrix4fv(this.program.uniforms.u_modelMatrix, false, this.moonTransform.getMatrix(frameInfo.timestampMS, properties));
        this.moonVao.draw();
    }
}